<button
  type="button"
  class="cbb-table-action-icon"
  [class.cbb-table-action-icon--void]="variant === 'void'"
  [class.cbb-table-action-icon--reactivate]="variant === 'reactivate'"
  [class.cbb-table-action-icon--inactive]="!active"
  [disabled]="disabled"
  [attr.title]="label || null"
  [attr.aria-label]="ariaLabel()"
  (click)="emitClick($event)"
>
  @if (variant === 'edit') {
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 -960 960 960"
      aria-hidden="true"
      class="cbb-table-action-icon__svg"
    >
      <path
        fill="currentColor"
        d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"
      />
    </svg>
  } @else if (variant === 'reactivate') {
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      class="cbb-table-action-icon__svg"
    >
      <path
        d="M19 8V4M19 4H15M19 4L15.5 7.5C14.43 6.55 13.02 6 11.5 6C8.19 6 5.5 8.69 5.5 12C5.5 15.31 8.19 18 11.5 18C14.05 18 16.23 16.41 17.1 14.17"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  } @else {
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      class="cbb-table-action-icon__svg"
    >
      <path
        d="M8.1 17L7 15.9L11.4 11.5L7 7.1L8.1 6L12.5 10.4L16.9 6L18 7.1L13.6 11.5L18 15.9L16.9 17L12.5 12.6L8.1 17Z"
        stroke="currentColor"
        fill="currentColor"
      />
      <circle cx="12.5" cy="11.5" r="11" stroke="currentColor" fill="none" />
    </svg>
  }
</button>
